/**
 * @file <Redirect> wrapper for setting correct status for SSR.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

const propTypes = {
  status: PropTypes.oneOf([301, 302, 303]).isRequired,
  from: PropTypes.string,
  to: PropTypes.string.isRequired,
};

const RedirectWithStatus = ({ status, from, to }) => (
  <Route
    render={({ staticContext, location }) => {
      // there is no `staticContext` on the client, so
      // we need to guard against that here
      if (staticContext) {
        staticContext.status = status; // eslint-disable-line no-param-reassign
      }

      return (
        <Redirect
          from={from}
          to={{
            pathname: to,
            search: location.search,
          }}
        />
      );
    }}
  />
);

RedirectWithStatus.propTypes = propTypes;

export default RedirectWithStatus;
